import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useDonation } from "../Components/DonationContext";
import { useNavigate } from "react-router-dom";
import "./CrecheProgram.css";

// Animation variants for Framer Motion
const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const staggerItem = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

/* ---------------- Inline icon set (no external icon package needed) ---------------- */

const IconHouseHeart = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 24L24 10l16 14" stroke="#1a6b3c" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 21v15a2 2 0 002 2h20a2 2 0 002-2V21" stroke="#1a6b3c" strokeWidth="2.2" strokeLinejoin="round" />
    <path
      d="M24 32c-4-2.6-7-5-7-8.2a3.6 3.6 0 017-1.6 3.6 3.6 0 017 1.6c0 3.2-3 5.6-7 8.2z"
      stroke="#1a6b3c"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

const IconUsersFilled = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M2.8 20c.7-3.6 3.3-5.6 6.2-5.6s5.5 2 6.2 5.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M15.5 5.4a3.2 3.2 0 010 6.2M18.8 20c-.5-2.6-1.9-4.4-3.8-5.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconTeacher = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="22" y="8" width="18" height="13" rx="1.5" stroke="#1a6b3c" strokeWidth="2" />
    <path d="M26 14h10M26 17h6" stroke="#1a6b3c" strokeWidth="1.8" strokeLinecap="round" />
    <circle cx="12" cy="16" r="4.2" stroke="#1a6b3c" strokeWidth="2" />
    <path d="M6 34c0-6 3.5-9.5 9-9.5s9 3.5 9 9.5" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconGroup = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="14" r="5" stroke="#1a6b3c" strokeWidth="2" />
    <circle cx="12" cy="19" r="4" stroke="#1a6b3c" strokeWidth="2" />
    <circle cx="36" cy="19" r="4" stroke="#1a6b3c" strokeWidth="2" />
    <path d="M14 34c0-6.5 4.5-10.5 10-10.5s10 4 10 10.5" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
    <path d="M6 32c.6-4.5 3-7 6.5-7.6M42 32c-.6-4.5-3-7-6.5-7.6" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconBowl = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 22h32a16 16 0 01-32 0z" stroke="#1a6b3c" strokeWidth="2" strokeLinejoin="round" />
    <path d="M14 22c0-6 4-9 10-9s10 3 10 9" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
    <path d="M24 8v3M18 9.5l1.2 2.6M30 9.5l-1.2 2.6" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
    <path d="M18 38h12" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconCross = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="16" stroke="#1a6b3c" strokeWidth="2" />
    <path d="M24 17v14M17 24h14" stroke="#1a6b3c" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

const IconBook = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 14c-3.5-2.5-8-3-13-2v22c5-1 9.5-.5 13 2 3.5-2.5 8-3 13-2V12c-5-1-9.5-.5-13 2z" stroke="#1a6b3c" strokeWidth="2" strokeLinejoin="round" />
    <path d="M24 14v22" stroke="#1a6b3c" strokeWidth="2" />
  </svg>
);

const IconHeart = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21s-7.5-4.6-10-9.3C.4 8.3 2 4.5 5.6 4c2.1-.3 4 .8 6.4 3 2.4-2.2 4.3-3.3 6.4-3 3.6.5 5.2 4.3 3.6 7.7C19.5 16.4 12 21 12 21z" />
  </svg>
);

const IconHandHeart = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 38c-4-4-7-8-7-13a7 7 0 0114-1 7 7 0 0114 1c0 5-3 9-7 13l-7 7-7-7z"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path
      d="M14 34c-3 3-6 7-6 12 0 5 4 9 9 9h9c4 0 7-2 10-5l9-9c1.5-1.5 1.5-3.7 0-5-1.4-1.3-3.4-1.2-4.8.1l-6.2 6"
      fill="#ef7f3a"
    />
  </svg>
);

/* ------------------------------------------------------------------------------------ */

const CrecheProgram = () => {
  const features = [
    {
      title: "Training",
      text: "Crèche leaders are thoroughly trained in center maintenance and child care.",
      icon: <IconTeacher />,
    },
    {
      title: "Managing Committee",
      text: "Each center is run by a committee with 50% women members, ensuring community ownership.",
      icon: <IconGroup />,
    },
    {
      title: "Nutritional Food",
      text: "Children are provided with a balanced and nutritious diet to support their growth and development.",
      icon: <IconBowl />,
    },
    {
      title: "Health Checkups",
      text: "Regular health check-ups are conducted by local medical functionaries, and a first-aid unit is maintained.",
      icon: <IconCross />,
    },
    {
      title: "Information Material",
      text: "Play materials and educational posters are provided to each child center to stimulate learning.",
      icon: <IconBook />,
    },
  ];

  const { openDonation } = useDonation();
  const navigate = useNavigate();

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="cp-hero">
        <div
          className="cp-hero__bg"
          style={{
            backgroundImage: "url(/assets/images/backgrounds/creche1.png)",
          }}
        ></div>
        <div className="cp-hero__overlay"></div>
        <div className="cp-hero__dots"></div>

        <div className="cp-hero__logo">
          <IconHandHeart />
        </div>

        <svg className="cp-hero__wave" viewBox="0 0 200 260" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 2c30 20-20 45 10 65s45-10 60 15-10 40 20 60"
            stroke="#ef7f3a"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>

        <Container className="cp-hero__content">
          <motion.h1
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Creche
            <br />
            <span>Program</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            Vikash's crèche program provides a safe and nurturing
            environment for young children, allowing parents to work while
            ensuring quality care and early learning.
          </motion.p>
        </Container>
      </section>

      {/* Introduction Section */}
      <section className="cp-intro">
        <Container>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={staggerContainer}
          >
            <Row className="align-items-center g-5">
              <motion.div className="col-lg-6" variants={staggerItem}>
                <div className="cp-icon-badge">
                  <IconHouseHeart />
                </div>
                <h2 className="cp-heading">
                  Safe Spaces for
                  <br />
                  <span>Early Development</span>
                </h2>
                <span className="cp-underline"></span>
                <p className="cp-text">
                  Vikash has established essential crèche centers in 10
                  villages of Gop Block (Puri district) and 5 villages of
                  Ersama block (Jagatsinghpur district). These centers
                  provide a secure and stimulating environment for young
                  children, ensuring their well-being while their parents
                  are at work.
                </p>
              </motion.div>

              <motion.div className="col-lg-6" variants={staggerItem}>
                <div className="cp-intro__imgwrap">
                  <img
                    src="/assets/images/Subsections/cp1.jpg"
                    alt="Children at a creche center"
                    className="cp-intro__img"
                  />
                  <div className="cp-intro__badge">
                    <div className="cp-intro__badge-icon">
                      <IconUsersFilled />
                    </div>
                    <div>
                      <strong>Nurturing today,</strong>
                      <span>building a brighter tomorrow.</span>
                    </div>
                  </div>
                </div>
              </motion.div>
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* Key Features Section */}
      <section className="cp-features">
        <div className="cp-features__leaf cp-features__leaf--left">
          <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M60 150V40" stroke="#cddccf" strokeWidth="3" />
            <path d="M60 60c-15-15-35-15-45-5 10 15 30 15 45 5z" fill="#cddccf" />
            <path d="M60 90c15-15 35-15 45-5-10 15-30 15-45 5z" fill="#cddccf" />
            <path d="M60 120c-12-12-28-12-36-4 8 12 24 12 36 4z" fill="#cddccf" />
          </svg>
        </div>
        <div className="cp-features__leaf cp-features__leaf--right">
          <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M60 150V40" stroke="#cddccf" strokeWidth="3" />
            <path d="M60 60c-15-15-35-15-45-5 10 15 30 15 45 5z" fill="#cddccf" />
            <path d="M60 90c15-15 35-15 45-5-10 15-30 15-45 5z" fill="#cddccf" />
            <path d="M60 120c-12-12-28-12-36-4 8 12 24 12 36 4z" fill="#cddccf" />
          </svg>
        </div>

        <Container>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
            className="text-center cp-features__head"
          >
            <div className="cp-eyebrow">
              <span className="cp-eyebrow__dash"></span>
              Features of Our
              <span className="cp-eyebrow__dash"></span>
            </div>
            <h2 className="cp-heading cp-heading--center">
              Creche <span>Program</span>
            </h2>
            <p className="cp-subtext">
              We provide comprehensive support for the holistic development
              of every child.
            </p>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={staggerContainer}
          >
            <Row className="g-4 justify-content-center">
              {features.map((feature, index) => (
                <Col md={6} lg={4} key={index}>
                  <motion.div variants={staggerItem} className="h-100">
                    <Card className="cp-card h-100">
                      <Card.Body>
                        <div className="cp-card__icon">{feature.icon}</div>
                        <Card.Title as="h5">{feature.title}</Card.Title>
                        <span className="cp-card__underline"></span>
                        <Card.Text>{feature.text}</Card.Text>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* Call To Action Section */}
      <section className="cp-cta">
        <Container>
          <motion.div
            className="cp-cta__panel"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
          >
            <div className="cp-cta__dots"></div>
            <div className="cp-cta__leaf">
              <svg viewBox="0 0 120 160" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M60 150V40" stroke="#f0c2a0" strokeWidth="3" />
                <path d="M60 60c-15-15-35-15-45-5 10 15 30 15 45 5z" fill="#f0c2a0" />
                <path d="M60 90c15-15 35-15 45-5-10 15-30 15-45 5z" fill="#f0c2a0" />
                <path d="M60 120c-12-12-28-12-36-4 8 12 24 12 36 4z" fill="#f0c2a0" />
              </svg>
            </div>

            <Row className="align-items-center g-4">
              <Col lg={5} className="text-center">
                <div className="cp-cta__imgwrap">
                  <div className="cp-cta__icon">
                    <IconHeart />
                  </div>
                  <img
                    src="/assets/images/backgrounds/do2.png"
                    alt="Child at a creche center"
                    className="cp-cta__img"
                  />
                </div>
              </Col>

              <Col lg={7}>
                <h2 className="cp-cta__title">
                  Support Early
                  <br />
                  <span>Childhood Care</span>
                </h2>
                <span className="cp-underline"></span>
                <p className="cp-cta__text">
                  Your contribution helps us provide nutritious meals,
                  learning materials, and a safe environment for young
                  children.
                </p>
                <div className="cp-cta__actions">
                  <Button className="cp-btn cp-btn--solid" onClick={openDonation}>
                    <IconHeart /> Donate Now
                  </Button>
                  <Button
                    className="cp-btn cp-btn--outline"
                    onClick={() => navigate("/interns")}
                  >
                    <IconUsersFilled /> Join Us
                  </Button>
                </div>
              </Col>
            </Row>
          </motion.div>
        </Container>
      </section>

      <Footer />

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};

export default CrecheProgram;